<template>
  <el-cascader
    :value="value"
    :options="options"
    :props="props"
    v-bind="$attrs"
    v-on="$listeners"
    ref="cascader"
  >
  </el-cascader>
</template>

<script>
import {
  getEmptyArray
} from "../../../utils"

import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus } from '../../../utils/china-area-data.js'

export default {
  name: 'ProvinceCityDistrict',
  props: {
    value: Array,
    valueKey: {
      type: String,
      default: 'name'
    },
    selectAllOption: Boolean,
    onlyProvinceAndCity: Boolean
  },
  computed: {
    props () {
      return {
        value: this.valueKey === 'name' ? 'name' : 'value'
      }
    },
    options () {
      let options

      if (this.selectAllOption) {
        if (this.onlyProvinceAndCity) {
          options = provinceAndCityDataPlus
        } else {
          options = regionDataPlus
        }
      } else {
        if (this.onlyProvinceAndCity) {
          options = provinceAndCityData
        } else {
          options = regionData
        }
      }

      return options
    }
  }
}
</script>